import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '@reenstudio/app/shared/components/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  error(message: string, action?: string) {
    this.openSnackbar('snackbar-error', 'error', message, action);
  }

  warning(message: string, action?: string) {
    this.openSnackbar('snackbar-warning', 'warning', message, action);
  }

  success(message: string, action?: string): void {
    this.openSnackbar('snackbar-success', 'done', message, action);
  }

  private openSnackbar(
    panelClass: string,
    icon: string,
    message: string,
    action?: string
  ) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: {
        icon: icon,
        message: message,
        action: action ?? 'Ok',
      },
      panelClass: panelClass,
      duration: 3000,
    });
  }
}
